/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisableClientNotificationRequest
 */
export interface DisableClientNotificationRequest {
    /**
     * 
     */
    clientUUID: string;
}

/**
 * Check if a given object implements the DisableClientNotificationRequest interface.
 */
export function instanceOfDisableClientNotificationRequest(value: object): value is DisableClientNotificationRequest {
    if (!('clientUUID' in value) || value['clientUUID'] === undefined) return false;
    return true;
}

export function DisableClientNotificationRequestFromJSON(json: any): DisableClientNotificationRequest {
    return DisableClientNotificationRequestFromJSONTyped(json, false);
}

export function DisableClientNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisableClientNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientUUID': json['clientUUID'],
    };
}

export function DisableClientNotificationRequestToJSON(json: any): DisableClientNotificationRequest {
    return DisableClientNotificationRequestToJSONTyped(json, false);
}

export function DisableClientNotificationRequestToJSONTyped(value?: DisableClientNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientUUID': value['clientUUID'],
    };
}

